module.exports = __webpack_public_path__ + "static/img/li_01.b7c8c63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/li_01.jpg
// module id = DiYu
// module chunks = 0